/**
 * Who the signed-in person is, for the account menu, avatar and greeting
 * (ALL-5481). Role ids are authorisation data, never identity: they are not
 * accepted here at all. Order: session display name, then the email local
 * part made readable, then the email, then a neutral label.
 */

export interface UserIdentity {
  name: string;
  email: string;
  initials: string;
}

interface IdentitySource {
  displayName?: unknown;
  email?: unknown;
  [key: string]: unknown;
}

function text(input: unknown): string {
  return typeof input === "string" ? input.trim() : "";
}

function humaniseLocalPart(email: string): string {
  const local = email.split("@")[0] ?? "";
  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function initialsOf(name: string): string {
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

export function resolveUserIdentity(source: IdentitySource): UserIdentity {
  const email = text(source.email);
  const name = text(source.displayName) || humaniseLocalPart(email) || email;
  if (!name) return { name: "User", email: "", initials: "U" };
  return { name, email, initials: initialsOf(name) };
}
